import { PROPOSAL_DATA } from "@proposalaction";

export let proposalData = (state = {}, action) => {
  if (action.type === PROPOSAL_DATA) {
    return action.payload;
  }
  return state;
};
